import React from 'react';
import { Alert, Col, FormControl, FormGroup, HelpBlock, Panel, Row } from 'react-bootstrap';

interface IProps {
    centerId: number,
    returnName: string,
    returnAddress1: string,
    returnAddress2: string,
    returnCity: string,
    returnState: string,
    returnPostalCode: string,
    returnContactPhone: string,
    disableElements: boolean,
    onFieldChange: (name: string, value: string) => void
}

const ReturnTo = (props: IProps) => {
    const handleFieldChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        props.onFieldChange(name, value);
    };

    const isReturnNameTooShort = props.returnName.length > 0 && props.returnName.length <= 5;

    return (
        <Panel bsStyle='primary'>
            <Panel.Heading>Where should we return the blood?</Panel.Heading>

            <Panel.Body>
                <Alert bsStyle='danger'>Please verify that the address is auto-filled correctly. We have pre-populated using details from the <a href={`/center/${props.centerId}/profile/addresses`}>Laboratory Address</a> (if available).</Alert>

                <FormGroup validationState={isReturnNameTooShort ? 'error' : null}>
                    <label>Name:<span style={{ color: 'red' }}>*</span></label>
                    <FormControl
                        name='returnName'
                        value={props.returnName}
                        placeholder='Lab name or full contact name'
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    />
                    {isReturnNameTooShort && <HelpBlock>Name must be more than 5 characters. Enter the lab name or the contact's first and last name.</HelpBlock>}
                </FormGroup>

                <FormGroup>
                    <label>Address 1:<span style={{ color: 'red' }}>*</span></label>
                    <FormControl
                        name='returnAddress1'
                        value={props.returnAddress1}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    />
                </FormGroup>

                <FormGroup>
                    <label>Address 2:</label>
                    <FormControl
                        name='returnAddress2'
                        value={props.returnAddress2}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    />
                </FormGroup>

                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <label>City:<span style={{ color: 'red' }}>*</span></label>
                            <FormControl
                                name='returnCity'
                                value={props.returnCity}
                                onChange={handleFieldChange}
                                disabled={props.disableElements}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <label>State:<span style={{ color: 'red' }}>*</span></label>
                            <FormControl
                                name='returnState'
                                value={props.returnState}
                                onChange={handleFieldChange}
                                disabled={props.disableElements}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={4}>
                        <FormGroup>
                            <label>Postal Code:<span style={{ color: 'red' }}>*</span></label>
                            <FormControl
                                name='returnPostalCode'
                                maxLength={5}
                                value={props.returnPostalCode}
                                onChange={handleFieldChange}
                                disabled={props.disableElements}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup>
                    <label>Contact Phone:</label>
                    <FormControl
                        name='returnContactPhone'
                        maxLength={10}
                        value={props.returnContactPhone}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    />
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default ReturnTo;